import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>WB Class 10: Exam Preparation</p>
      </header>
    </div>
  );
}

export default App;
